<template>
  <div class="addOnlineContainer">
    <section>
      <h2>
        一、批量新增应付费用
        <a @click="downloadExample">【 下载示例excel 】</a>
      </h2>
      <input type="file" @change="excelData" />
      <a-button type="primary" @click="submitUpload">{{
        upTxtAdvance
      }}</a-button>
    </section>
    <section>
      <h2>
        二、批量新增应收费用
        <a @click="downloadExampleReceivable">【 下载示例excel 】</a>
      </h2>
      <input type="file" @change="excelDataReceivable" />
      <a-button type="primary" @click="submitUploadReceivable">{{
        upTxtReceivable
      }}</a-button>
    </section>
    <section>
      <h2>
        三、预支批量出账
      </h2>
      <input type="file" @change="excelDataAdvance" />
      <a-button type="primary" @click="submitUploadAdvance">{{
        upTxtAdvance
      }}</a-button>
    </section>
    <!-- <section>
      <h2>
        三、批量新增预支手续费(系统审核至结算完成)
        <a @click="downloadExampleBatchAdvance">【 下载示例excel 】</a>
      </h2>
      <input type="file" @change="excelDataBatchAdvance" />
      <a-button type="primary" @click="submitUploadBatchAdvance">{{
        upTxtBatchAdvance
      }}</a-button>
    </section> -->
    <div class="hint">
      <h3>注意事项</h3>
      <span>1、 必须为.xls或.xlsx结尾的excel；</span>
      <span>2、表格中不得有空行空列，无数据填0；</span>
      <span>3、表格中所有数据均为文本格式；</span>
      <span>4、表格中日期格式以-作为连接符(如2020-10)。</span>
    </div>

    <!-- 加载动画 -->
    <a-spin
      style="position: absolute;left: 0;top: 250px;right: 0;bottom: 0;margin: auto;"
      tip="表格上传中,请稍后..."
      v-show="loading"
      size="large"
    >
    </a-spin>
    <!-- 加载动画 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      attence: "",
      attenceFile: "",
      downloadTxt: "下载",
      upTxt: "上传",
      advanceCashierFile: "",
      upTxtAdvance: "上传",
      batchAdvanceFile: "",
      upTxtBatchAdvance: "上传",
      loading: false,
      receivableFile: "",
      upTxtReceivable: "上传"
    };
  },
  methods: {
    downloadExampleReceivable() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance/batchAddReceiveDownloadTpl?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    excelDataReceivable(e) {
      this.receivableFile = e.target.files[0];
    },
    submitUploadReceivable() {
      let _this = this;
      if (this.receivableFile != "") {
        this.$confirm({
          title:
            "表格一旦上传，费用批量新增，确认无误后进行操作，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcelReceivable();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传");
      }
    },
    upExcelReceivable() {
      this.upTxtReceivable = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.receivableFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance/batchAddReceive";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.$emit("hideInAddBetch", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upTxtReceivable = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxtReceivable = "上传";
    },
    excelDataAdvance(e) {
      this.advanceCashierFile = e.target.files[0];
    },
    submitUploadAdvance() {
      let _this = this;
      if (this.advanceCashierFile != "") {
        this.$confirm({
          title:
            "表格一旦上传，表格中预支即出账成功，确认无误后进行操作，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcelAdvance();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传");
      }
    },
    upExcelAdvance() {
      this.loading = true;
      this.upTxtAdvance = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.advanceCashierFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Advance_record_project/advanceRecordProjectUpload";
      axios
        .post(url, formData, config)
        .then(res => {
          this.loading = false;
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.$emit("hideInAddBetch", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upTxt = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxtAdvance = "上传";
    },
    excelData(e) {
      this.attence = e.target.files[0].name;
      this.attenceFile = e.target.files[0];
    },
    downloadExample() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance/batchAddDownloadTpl?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    submitUpload() {
      let _this = this;
      if (this.attenceFile != "") {
        this.$confirm({
          title:
            "表格一旦上传，费用批量新增，确认无误后进行操作，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传");
      }
    },
    upExcel() {
      this.upTxtAdvance = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.attenceFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance/batchAdd";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.$emit("hideInAddBetch", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upTxtAdvance = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxtAdvance = "上传";
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  padding: 30px 4%;
  position: relative;
  h2 {
    font-weight: normal;
    a {
      font-size: 14px;
      display: inline-block;
      margin-left: 20px;
    }

    > span {
      font-size: 14px;
    }
  }
  input {
    margin: 20px 30px;
  }
  button {
    display: block;
    margin: 0 30px 50px;
  }
  .hint {
    background: rgba(230, 162, 60, 0.1);
    padding: 10px 20px;
    margin: 10px 30px 20px;
    width: 400px;
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 1;
    h3 {
      color: #666;
      font-size: 16px;
      font-weight: normal;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #666;
    }
  }
}
</style>
